import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { site } from "@/mocks/site";

const contactCards = [
  {
    icon: "ri-whatsapp-line",
    label: "WhatsApp",
    value: "0 553 730 71 30",
    href: "https://wa.me/905537307130?text=Merhaba%2C%20randevu%20almak%20istiyorum.",
    external: true,
  },
  {
    icon: "ri-phone-line",
    label: "Telefon",
    value: "0 212 343 30 30",
    href: "tel:+902123433030",
    external: false,
  },
  {
    icon: "ri-mail-line",
    label: "E-posta",
    value: "dmar.erguvan@gmail.com",
    href: "mailto:dmar.erguvan@gmail.com",
    external: false,
  },
  {
    icon: "ri-map-pin-line",
    label: "Adres",
    value: "Osmanbey / Şişli, İstanbul",
    href: "https://www.google.com/maps/place/D.mar+Dental+G%C3%B6r%C3%BCnt%C3%BCleme+Merkezi/@41.0539658,28.9864392,17z",
    external: true,
  },
];

export default function ContactSection() {
  return (
    <section id="iletisim" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="shell">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-14">
          <div>
            <Reveal>
              <SectionHeading
                align="left"
                eyebrow="Randevu & iletişim"
                title="Merkezimize kolayca ulaşın"
                description="Halaskargazi Caddesi üzerinde, metro ve otobüsle kolay ulaşım. Randevu ve sorularınız için WhatsApp en hızlı kanaldır."
              />
            </Reveal>

            <Reveal delay={80}>
              <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {contactCards.map((card) => (
                  <a
                    key={card.label}
                    href={card.href}
                    {...(card.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    className="group relative flex cursor-pointer items-start gap-4 overflow-hidden rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
                  >
                    <span
                      className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
                      aria-hidden="true"
                    />
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 ring-1 ring-inset ring-primary-300/60 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                      <i className={`${card.icon} text-lg`} aria-hidden="true" />
                    </span>
                    <span className="flex flex-col">
                      <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-foreground-500">
                        {card.label}
                      </span>
                      <span className="mt-1 text-sm font-semibold text-foreground-900">
                        {card.value}
                      </span>
                    </span>
                  </a>
                ))}
              </div>
            </Reveal>

            <Reveal delay={140}>
              <div className="mt-6 rounded-xl border border-background-200 bg-background-50 p-6">
                <h3 className="flex items-center gap-2 font-heading text-base font-medium text-foreground-950">
                  <i className="ri-time-line text-base text-primary-600" aria-hidden="true" />
                  Çalışma saatleri
                </h3>
                <dl className="mt-4 flex flex-col gap-2.5">
                  {site.hours.map((row) => (
                    <div key={row.day} className="flex items-center justify-between gap-4 text-sm">
                      <dt className="text-foreground-600">{row.day}</dt>
                      <dd className="font-semibold text-foreground-900">{row.value}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </Reveal>
          </div>

          <div className="flex flex-col gap-6">
            <Reveal delay={120}>
              <div className="relative overflow-hidden rounded-xl bg-primary-700 p-7 text-background-50 md:p-9">
                <span
                  className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
                  aria-hidden="true"
                />
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-background-50/15 ring-1 ring-inset ring-background-50/20">
                  <i className="ri-whatsapp-line text-2xl" aria-hidden="true" />
                </span>
                <h3 className="mt-6 font-heading text-2xl font-medium">
                  Randevunuzu WhatsApp'tan alın
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-background-50/80">
                  Diş hekiminizin istediği filmi yazmanız yeterli; genellikle aynı gün için uygun saat
                  bulunur. Acil durumlar için de en hızlı kanal WhatsApp'tır.
                </p>
                <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                  <a
                    href="https://wa.me/905537307130?text=Merhaba%2C%20randevu%20almak%20istiyorum."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
                  >
                    <i className="ri-whatsapp-line text-base" aria-hidden="true" />
                    WhatsApp'tan yaz
                  </a>
                  <a
                    href="tel:+902123433030"
                    className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                  >
                    <i className="ri-phone-line text-base" aria-hidden="true" />
                    Hemen ara
                  </a>
                </div>
              </div>
            </Reveal>

            <Reveal delay={180}>
              <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                <iframe
                  title="D.mar Dental Görüntüleme Merkezi konumu — Osmanbey / Şişli, İstanbul"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.627699639873!2d28.98713469259033!3d41.05527001801697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab711fb81d4b9%3A0x990d979d20e78cd7!2sD.mar%20Dental%20G%C3%B6r%C3%BCnt%C3%BCleme%20Merkezi!5e0!3m2!1str!2str!4v1790352178135!5m2!1str!2str"
                  width="600"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                  className="h-64 w-full md:h-72"
                />
                <div className="border-t border-background-200 p-5">
                  <p className="text-sm text-foreground-600">
                    {site.address}{" "}
                    <a
                      href={site.directions}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer font-semibold text-primary-700 underline decoration-primary-300 underline-offset-4 hover:text-primary-500"
                    >
                      Yol tarifi al
                    </a>
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}